import React, { useEffect } from "react";
import OfferLetterRenewalComponent from "./offer-letter-renewal.component";

const OfferLetterRenewalPage = (): JSX.Element => {
  return <OfferLetterRenewalComponent />;
};

export default OfferLetterRenewalPage;
